import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronLeft, ChevronRight } from 'lucide-react';
export function Testimonials() {
  const testimonials = [{
    quote: 'Desde que llevamos a Luna a Terra Vet, su calidad de vida cambió por completo.',
    author: 'María G.',
    image: 'https://images.unsplash.com/photo-1543466835-00a7907e9de1?w=400&q=80'
  }, {
    quote: 'El equipo nos dio la tranquilidad que necesitábamos en un momento muy difícil.',
    author: 'Carlos P.',
    image: 'https://images.unsplash.com/photo-1574158622682-e40e69881006?w=400&q=80'
  }, {
    quote: 'Profesionalismo y cariño en cada visita. No los cambiaríamos por nada.',
    author: 'Ana L.',
    image: 'https://images.unsplash.com/photo-1583511655857-d19b40a7a54e?w=400&q=80'
  }];
  const [currentIndex, setCurrentIndex] = useState(0);
  const [direction, setDirection] = useState(0);
  const slideVariants = {
    enter: (direction: number) => ({
      x: direction > 0 ? 100 : -100,
      opacity: 0
    }),
    center: {
      zIndex: 1,
      x: 0,
      opacity: 1
    },
    exit: (direction: number) => ({
      zIndex: 0,
      x: direction < 0 ? 100 : -100,
      opacity: 0
    })
  };
  const swipeConfidenceThreshold = 10000;
  const swipePower = (offset: number, velocity: number) => {
    return Math.abs(offset) * velocity;
  };
  const paginate = (newDirection: number) => {
    setDirection(newDirection);
    setCurrentIndex(prevIndex => {
      let nextIndex = prevIndex + newDirection;
      if (nextIndex < 0) nextIndex = testimonials.length - 1;
      if (nextIndex >= testimonials.length) nextIndex = 0;
      return nextIndex;
    });
  };
  return <section id="testimonios" className="py-24 md:py-32 bg-[#F0EBE6]" data-id="element-116">
      <div className="max-w-7xl mx-auto px-6 md:px-12" data-id="element-117">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8,
        ease: [0.22, 1, 0.36, 1]
      }} className="text-center mb-16" data-id="element-118">
          <h2 className="text-4xl md:text-5xl text-matte" data-id="element-119">
            Lo que dicen sus humanos
          </h2>
        </motion.div>

        <div className="relative max-w-4xl mx-auto h-[400px] md:h-[300px] flex items-center justify-center" data-id="element-120">
          <AnimatePresence initial={false} custom={direction} data-id="element-121">
            <motion.div key={currentIndex} custom={direction} variants={slideVariants} initial="enter" animate="center" exit="exit" transition={{
            x: {
              type: 'spring',
              stiffness: 300,
              damping: 30
            },
            opacity: {
              duration: 0.2
            }
          }} drag="x" dragConstraints={{
            left: 0,
            right: 0
          }} dragElastic={1} onDragEnd={(e, {
            offset,
            velocity
          }) => {
            const swipe = swipePower(offset.x, velocity.x);
            if (swipe < -swipeConfidenceThreshold) {
              paginate(1);
            } else if (swipe > swipeConfidenceThreshold) {
              paginate(-1);
            }
          }} className="absolute w-full flex flex-col md:flex-row items-center gap-8 md:gap-12 px-12" data-id="element-122">
              <div className="w-32 h-32 md:w-48 md:h-48 shrink-0 overflow-hidden rounded-full bg-sand/20 shadow-lg" data-id="element-123">
                <img src={testimonials[currentIndex].image} alt={`Mascota de ${testimonials[currentIndex].author}`} className="w-full h-full object-cover" data-id="element-124" />
              </div>
              <div className="text-center md:text-left" data-id="element-125">
                <p className="font-serif text-2xl md:text-3xl text-matte italic mb-6 leading-relaxed" data-id="element-126">
                  "{testimonials[currentIndex].quote}"
                </p>
                <p className="text-terracotta tracking-widest uppercase text-sm" data-id="element-127">
                  — {testimonials[currentIndex].author}
                </p>
              </div>
            </motion.div>
          </AnimatePresence>

          {/* Navigation Buttons */}
          <button className="absolute left-0 z-10 p-2 text-matte/50 hover:text-olive transition-colors" onClick={() => paginate(-1)} aria-label="Anterior testimonio" data-id="element-128">
            <ChevronLeft size={32} strokeWidth={1} data-id="element-129" />
          </button>
          <button className="absolute right-0 z-10 p-2 text-matte/50 hover:text-olive transition-colors" onClick={() => paginate(1)} aria-label="Siguiente testimonio" data-id="element-130">
            <ChevronRight size={32} strokeWidth={1} data-id="element-131" />
          </button>
        </div>

        {/* Dots */}
        <div className="flex justify-center gap-3 mt-8" data-id="element-132">
          {testimonials.map((_, index) => <button key={index} onClick={() => {
          setDirection(index > currentIndex ? 1 : -1);
          setCurrentIndex(index);
        }} className={`w-2 h-2 rounded-full transition-all duration-300 ${index === currentIndex ? 'bg-olive w-6' : 'bg-sand hover:bg-olive/50'}`} aria-label={`Ir al testimonio ${index + 1}`} data-id="element-133" />)}
        </div>
      </div>
    </section>;
}